import React from "react";
import "./checkoutdetails.css";
import DeliveryDetails from "../DeliveryDetails/DeliveryDetails";

const CheckoutDetails = () => {
    return (
        <div>
            <DeliveryDetails />
            
        </div>
    )
};

export default CheckoutDetails;